module.exports = __webpack_public_path__ + "img/img10.6a727967.svg";